<template>
  <div class="form-element">
    <div class="form-element__range">
      <input
        class="form-element__range__swipe"
        :style="objeStyle"
        type="range"
        name="range"
        min="0"
        max="100"
        v-model="val"
      />
      <input
        v-numeric
        class="form-element__range__input"
        type="tel"
        v-model="val"
        minlength="1"
        maxlength="3"
      />
    </div>
  </div>
</template>

<script>
import { numeric } from '@/directives/'
export default {
  props: {
    value: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      val: this.value
    }
  },
  directives: { numeric },
  computed: {
    objeStyle: function () {
      return `background: linear-gradient(to right, #5f749e 0%, #5f749e  ${this.val}%, #d3dcee ${this.val}%, #d3dcee 100%)`
    }
  },
  watch: {
    val: function (val) {
      if (!val) return (this.val = 0)
      let num = parseInt(val)
      this.val = num
      if (num > 100) this.val = 100

      this.$emit('input', val)
    }
  }
}
</script>